import * as actions from './actions';
import * as getters from './getters';
import { SET_EVENT_COUNTER } from '../../mutation-types';


const mutations = {
  [SET_EVENT_COUNTER](state, payload) {
    state.event = payload
  },
};

const state = {
  event: null,
  url: '/v1/next-event'
};

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};
